/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightWinkelLinksKreis: {
    name: 'big-light-winkel-links-kreis';
    data: string;
} = {
    name: 'big-light-winkel-links-kreis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 40 40"><path d="M15.551 8.205a.816.816 0 0 1 1.149 0v.001l10.64 10.651c.306.306.473.712.473 1.143s-.17.837-.471 1.14l-.001.002-10.64 10.65a.81.81 0 0 1-1.151 0 .813.813 0 0 1 0-1.15L26.182 20 15.549 9.356a.817.817 0 0 1 0-1.149z"/><path fill-rule="evenodd" d="M1.719 20c0 10.081 8.2 18.281 18.281 18.281S38.281 30.081 38.281 20 30.081 1.719 20 1.719 1.719 9.919 1.719 20m1.562 0c0-9.219 7.5-16.719 16.719-16.719S36.719 10.781 36.719 20 29.219 36.719 20 36.719 3.281 29.219 3.281 20" clip-rule="evenodd"/></svg>`,
};
